import { render, staticRenderFns } from "./HistoryItemTypeOrderPaid.vue?vue&type=template&id=0c074f62&scoped=true&"
import script from "./HistoryItemTypeOrderPaid.vue?vue&type=script&lang=js&"
export * from "./HistoryItemTypeOrderPaid.vue?vue&type=script&lang=js&"
import style0 from "./HistoryItemTypeOrderPaid.vue?vue&type=style&index=0&id=0c074f62&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c074f62",
  null
  
)

export default component.exports